import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Price } from '../Price.js';

var PriceWithAffix = (_param)=>{
    var { className , pricePrefix , priceSuffix  } = _param, priceProps = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "pricePrefix",
        "priceSuffix"
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames('price-with-affix', className)
    }, pricePrefix, /*#__PURE__*/ React.createElement(Price, swcHelpers.extends({}, priceProps)), priceSuffix);
};

export { PriceWithAffix };
//# sourceMappingURL=PriceWithAffix.js.map
